export default __webpack_public_path__ + "static/Iter1-7e9b7b1bf69dda3cfce016d628c012d0.png";